import React,{ useState, useEffect } from 'react';
import {Link} from 'react-router-dom';
import axios from '../../../interceptor/axios-config';
import Swal from 'sweetalert2';
import { IMAGES } from '../Dashboard/Content';
import { useStaffData } from '../../../context/StaffsDataContext';
import { useGrade } from '../../../context/GradeContext';
import Form from 'react-bootstrap/Form';
import config from '../../../config';


const initialFormData = {
    prefix:'', emp_id:'', first_name:'', last_name: '', teacher_for_class: 'no', dob: '', photo: null, email: '',  
    phone_no: '', address: '', place_of_birth: '', degree: '', university: '',
    nearest_city: '', joining_date: ''
  };

const AddNewTeacher = () => {

    const { staffData, refreshStaffData } = useStaffData();
    const { grade } = useGrade();

    // Class teacher assigned as Home Room Teacher 
    let assignedHR = [];
    if(staffData.length > 0){
        assignedHR = staffData.map(item => item.teacher_for_class);
    }

    // Find classes without Homeroom Teacher not Assigned 
    let availableHR = grade; //This means available classes for allocating Homeroom Teacher
    if(assignedHR.length > 0){
        availableHR = grade.filter(ug => !assignedHR.includes(ug.class_options));
    }

    // console.log(assignedHR);
    // console.log(availableHR.length);
    //API to save teacher's detail
    // const END_POINT = 'https://ussschool.in/api/staffs/addNewTeacher.php';
    function generateUniqueId() {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0'); // Get the day and pad with leading zero if needed
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Get the month (0-indexed) and pad with leading zero if needed
        const year = String(now.getFullYear());
        const randomNum = String(Math.floor(Math.random() * 10000)).padStart(4, '0'); // Generate a random 4-digit number and pad with leading zeros
        const uniqueId = `E${year}${day}${month}${randomNum}`;
        return uniqueId;
    }

    const [formData, setFormData] = useState(initialFormData);
    // type file for image 
    const [file, setFile] = useState(null)

    const fileHandler = (e) => {       
        setFile(e.target.files[0]);	

        const { name, value, type } = e.target;   

        if (type === 'file') {
        // Convert the selected file to Base64
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setFormData({ ...formData, [name]: reader.result });
        };
        if (file) {
            reader.readAsDataURL(file);
        }
        } else {
            setFormData({ ...formData, [name]: value });
        }	
    }

    const RemoveFile = () =>{
        setFile(null)
        setFormData({ ...formData, photo:null });
    }

    const clearInputs = () => {
        setFormData(initialFormData);
        setFile(null)
    }

    useEffect(()=>{
        if(formData.emp_id === ''){
            const employee_code = generateUniqueId();
            setFormData({
            ...formData,
            emp_id:employee_code
        });
        }
    },[formData.emp_id]);

    // console.log(formData.emp_id);

    const handleChange = (e) => {
        const { name, value, type } = e.target;   
        if (type === 'file') {
        // Convert the selected file to Base64
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setFormData({ ...formData, [name]: reader.result });
        };
        if (file) {
            reader.readAsDataURL(file);
        }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (event) => {
        console.log(formData);
        try {
          event.stopPropagation();
          if(formData.prefix !==''){
            // First POST request
                const addTeacher = await axios.post(
                    `${config.apiBaseUrl}/staffs/addNewTeacher.php`,
                    formData
                );
            
                console.log('Teacher is added:', addTeacher.data);

                setFormData(initialFormData);

                setFile(null);
                refreshStaffData();
                Swal.fire({
                    icon: 'success',
                    title: 'Teacher Detail Added',
                    text: 'New teacher added successfully',
                });
          }else{
            Swal.fire({
                icon: 'error',
                title: 'Oops! Title not selected',
                text: 'Please choose title and fill up the required fields',
            });
          }
        } catch (error) {
          console.error('POST request error:', error);
          // Handle errors for both requests here
        }
      };

    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="mb-0">Personal Details</h5>
                        </div>
                        <div className="card-body">
                        <div className="flex flex-wrap mx-3 mb-1">
                            <div className="file-input w-full px-9 mb-1 md:mb-0">
                                <label className="form-label text-primary" htmlFor="grid-first-name">
                                    Prefixes
                                </label>
                                <div className='flex'>
                                    <label className="flex form-label text-primary p-2">
                                        <input
                                            className='p-4'
                                            type="radio"
                                            name="prefix"
                                            value="mr"
                                            checked={formData.prefix === 'mr'}
                                            onChange={handleChange}
                                        />
                                    <span className='p-2'>Mr</span>
                                    </label>
                                    <span className="p-2"></span>
                                    <label className="flex form-label text-primary p-2">
                                        <input
                                            className='p-4'
                                            type="radio"
                                            name="prefix"
                                            value="miss"
                                            checked={formData.prefix === 'miss'}
                                            onChange={handleChange}
                                        />
                                    <span className='p-2'>Miss</span>
                                    </label>
                                    <span className="p-2"></span>
                                    <label className="flex form-label text-primary p-2">
                                        <input
                                            className='p-4'
                                            type="radio"
                                            name="prefix"
                                            value="madam"
                                            checked={formData.prefix === 'madam'}
                                            onChange={handleChange}
                                        />
                                    <span className='p-2'>Madam</span>
                                    </label>
                                    <span className="p-2"></span>
                                    <label className="flex form-label text-primary p-2">
                                        <input
                                            className='p-4'
                                            type="radio"
                                            name="prefix"
                                            value="sir"
                                            checked={formData.prefix === 'sir'}
                                            onChange={handleChange}
                                        />
                                    <span className='p-2'>Sir</span>
                                    </label>
                                    <span className="p-2"></span>
                                    <label className="flex form-label text-primary p-2">
                                        <input
                                            className='p-4'
                                            type="radio"
                                            name="prefix"
                                            value="headmaster"
                                            checked={formData.prefix === 'headmaster'}
                                            onChange={handleChange}
                                        />
                                    <span className='p-2'>Headmaster</span>
                                    </label>
                                    <span className="p-2"></span>
                                    <label className="flex form-label text-primary p-2">
                                        <input
                                            className='p-4'
                                            type="radio"
                                            name="prefix"
                                            value="headmistress"
                                            checked={formData.prefix === 'headmistress'}
                                            onChange={handleChange}
                                        />
                                    <span className='p-2'>Headmistress</span>
                                    </label>
                                    <span className="p-2"></span>
                                    <label className="flex form-label text-primary p-2">
                                        <input
                                            className='p-4'
                                            type="radio"
                                            name="prefix"
                                            value="principal"
                                            checked={formData.prefix === 'principal'}
                                            onChange={handleChange}
                                        />
                                    <span className='p-2'>Principal</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                            <div className="row">
                                <div className="col-xl-6 col-sm-6">
                                    <div className="mb-3">
                                        <label htmlFor="exampleFormControlInput1" className="form-label text-primary">First Name<span className="required">*</span></label>
                                        {/* <input type="text" className="form-control" id="exampleFormControlInput1" placeholder="James" /> */}

                                        <input                                                     
                                            type="text" 
                                            className="form-control" 
                                            id="exampleFormControlInput1"                                                     
                                            name="first_name"
                                            value={formData.first_name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="mb-3">
                                        <label htmlFor="exampleFormControlInput3" className="form-label text-primary">Email<span className="required">*</span></label>
                                        {/* <input type="email" className="form-control" id="exampleFormControlInput3" placeholder="hello@example.com" /> */}
                                        <input                                                    
                                            type="email" 
                                            className="form-control" 
                                            id="exampleFormControlInput3" 
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="exampleFormControlTextarea1" className="form-label text-primary">Address<span className="required">*</span></label>
                                        {/* <textarea className="form-control" id="exampleFormControlTextarea1" rows="5" /> */}
                                        <textarea                                                    
                                            type="text" 
                                            className="form-control" 
                                            id="exampleFormControlTextarea1" 
                                            rows="5"
                                            name="address"
                                            value={formData.address}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="exampleFormControlInput10" className="form-label">Date of Birth<span className="required">*</span></label>  
                                        <div style={{display:'grid'}}>
                                        <input                                                     
                                            type="date" 
                                            className="form-control" 
                                            id="exampleFormControlInput7"                                                     
                                            name="dob"
                                            value={formData.dob}
                                            onChange={handleChange}
                                        />
                                        </div>                                      
                                    </div> 
                                    <div className="mb-3">
                                        <label htmlFor="exampleFormControlInput8" className="form-label text-primary">Class Teacher<span className="required">*</span></label>
                                        <Form.Select className="form-control" name="teacher_for_class"  size="lg" style={{width:'100%'}} value={formData.teacher_for_class} onChange={handleChange}>
                                            {/* <option value="all">---All---</option> */}
                                            {availableHR.map((item, index) => 
                                                <option value={item.class_options} key={index}>{item.class_label}</option>
                                            )}
                                        </Form.Select>
                                    </div>                                     
                                </div>
                                <div className="col-xl-6 col-sm-6">
                                    <div className="mb-3">
                                        <label htmlFor="exampleFormControlInput4" className="form-label text-primary">Last Name<span className="required">*</span></label>
                                        {/* <input type="text" className="form-control" id="exampleFormControlInput4" placeholder="Lee" /> */}
                                        <input                                                     
                                            type="text" 
                                            className="form-control" 
                                            id="exampleFormControlInput1"                                                     
                                            name="last_name"
                                            value={formData.last_name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="exampleFormControlInput6" className="form-label text-primary">Phone Number<span className="required">*</span></label>
                                        {/* <input type="number" className="form-control" id="exampleFormControlInput6" placeholder="+123456789" /> */}
                                        <input                                                    
                                            type="number" 
                                            className="form-control" 
                                            id="exampleFormControlInput6" 
                                            name="phone_no"
                                            value={formData.phone_no}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label  className="form-label text-primary">Photo<span className="required">*</span></label>
                                        <div className="avatar-upload">
                                            <div className="avatar-preview">
                                                <div id="imagePreview"                                                     
                                                    style={{backgroundImage: file ? "url(" + URL.createObjectURL(file) + ")" : "url(" + IMAGES.noimage +")" }}
                                                > </div>
                                            </div>
                                            <div className="change-btn mt-1">
                                                <input type='file' className="form-control d-none" name='photo' onChange={fileHandler} id="imageUpload"  accept=".png, .jpg, .jpeg" />
                                                <label htmlFor="imageUpload" className="dlab-upload mb-0 btn btn-primary btn-sm"  >Choose File</label>
                                                <Link to={"#"} className="btn btn-danger light remove-img ms-2 btn-sm" onClick={RemoveFile}>Remove</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="exampleFormControlInput8" className="form-label text-primary">Place of Birth<span className="required">*</span></label>
                                        {/* <input type="text" className="form-control" id="exampleFormControlInput8" placeholder="USA" /> */}
                                        <input                                                     
                                            type="text" 
                                            className="form-control" 
                                            id="exampleFormControlInput1"                                                     
                                            name="place_of_birth"
                                            value={formData.place_of_birth}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-header">
                        <h5 className="mb-0">Education</h5>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-xl-6 col-sm-6">
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput9" className="form-label text-primary">Highest Degree <span className="required">*</span></label>
                                    {/* <input type="text" className="form-control" id="exampleFormControlInput9" placeholder="Highest Qualification" /> */}
                                    <input                                                     
                                            type="text" 
                                            className="form-control" 
                                            id="exampleFormControlInput1"                                                     
                                            name="degree"
                                            value={formData.degree}
                                            onChange={handleChange}
                                        />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput13" className="form-label text-primary">Nearest City<span className="required">*</span></label>
                                    {/* <input type="text" className="form-control" id="exampleFormControlInput13" placeholder="USA" /> */}
                                    <input                                                     
                                            type="text" 
                                            className="form-control" 
                                            id="exampleFormControlInput1"                                                     
                                            name="nearest_city"
                                            value={formData.nearest_city}
                                            onChange={handleChange}
                                        />
                                </div>
                            </div>
                            <div className="col-xl-6 col-sm-6">
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput14" className="form-label text-primary">University/BOARD<span className="required">*</span></label>
                                    {/* <input type="text" className="form-control" id="exampleFormControlInput14" placeholder="University" /> */}
                                    <input                                                     
                                            type="text" 
                                            className="form-control" 
                                            id="exampleFormControlInput1"                                                     
                                            name="university"
                                            value={formData.university}
                                            onChange={handleChange}
                                        />
                                </div>                             
            
                                <div className="mb-3">                                       
                                    <label className="form-label text-primary">Joining Date<span className="required">*</span></label>                                                                                   
                                    <div>
                                    <input                                                     
                                        type="date" 
                                        className="form-control" 
                                        id="exampleFormControlInput7"                                                     
                                        name="joining_date"
                                        value={formData.joining_date}
                                        onChange={handleChange}
                                    />
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <div className="float-end">
                            <button className="btn btn-outline-primary me-3" onClick={clearInputs}>Clear inputs</button>
                            <button className="btn btn-primary" type="button" onClick={handleSubmit}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    );
};

export default AddNewTeacher;